import { Component, Input, OnInit } from '@angular/core';
import { BatchAuftragDetailEntryMeta } from '../../../../../core/batch-auftrag-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { KopfdatenelementComponent } from '../../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { TranslatePipe } from '@ngx-translate/core';
import { DatumZeitPipe } from '../../../../../shared/pipes/simple/datumZeit.pipe';
import { KompaktBenutzerPipe } from '../../../../../shared/kompaktdarstellung/benutzer/kompakt-benutzer-pipe';

@Component({
  selector: 'cap-auftrag-kopfdaten',
  templateUrl: './auftrag-kopfdaten.component.html',
  imports: [KopfdatenelementComponent, TranslatePipe, DatumZeitPipe, KompaktBenutzerPipe]
})
export class AuftragKopfdatenComponent implements OnInit {
  @Input()
  auftragEntry: BatchAuftragDetailEntryMeta;

  constructor() {
    keysToTranslate(['AuftragsNr', 'AuftragsTyp', 'Verarbeitungsstatus', 'ErstelltVon', 'Erstelldatum', 'Startdatum', 'Enddatum']);
  }

  ngOnInit() {}
}
